<script>
import { StoryPageElementMixin } from "%/dynamic-component-editor/standard-pages/story-page/story-page-element-mixin";
import { DateElementMixin } from "%/dynamic-component-editor/standard-elements/text-element/date-element-mixin";
import BrandedTextStyleOptions from "%/dynamic-component-editor/bundles/branded-text-style-options";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";

export default {
  name: "StoryCreated",
  elementPanelSettings: {
    displayIcon: "text-alt",
    elementType: "element",
    displayName: "Story Created",
  },
  extends: TextElement,
  mixins: [StoryPageElementMixin, DateElementMixin],
  optionBundles: [
    new BrandedTextStyleOptions({}, {
      "text-option": true,
    }),
  ],
  computed: {
    shouldShowText() {
      return this.entity.timestampPublished;
    },
    value() {
      return this.formattedDate(this.entity.timestampPublished);
    },
    isEditable() {
      return false;
    },
  },
};
</script>
